import React from "react";
import img1 from "../../../assets/images/ncc/369189214_301194672488007_2698843757799967915_n.jpg";
import img2 from "../../../assets/images/ncc/sec.jpg";
import img3 from "../../../assets/images/ncc/third.jpg";
import img4 from "../../../assets/images/ncc/fourth.jpg";
const Cards = () => {
  return (
    <section className="mx-auto  text-black bg-slate-100 py-10 ">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 text-center sm:mx-auto  md:mt-20 lg:h-[68rem] md:max-w-full md:grid-cols-2 lg:grid-rows-5 md:text-left">
          <div className="row-span-3 bg-[rgba(238,155,105,0.2)] rounded-t-2xl ">
            <img
              className="h-72 md:h-96 lg:h-4/6  object-cover w-full rounded-t-3xl md:ml-0"
              src={img1}
              alt=""
            />
            <div className="px-6  pb-6 lg:pb-6 md:pb-0 text-start pt-4">
              <h3 className="text-4xl">Women's footware</h3>
              <p className="mt-6 text-base">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa
                ipsa delectus quod?
              </p>
              <button className="mt-4 rounded-lg bg-[rgba(238,155,105)] px-6 py-2 text-white transition hover:translate-y-1">
                Shop Now
              </button>
            </div>
          </div>

          <div className="row-span-2 bg-[rgb(3,124,193,0.2)] flex flex-col gap-4 rounded-t-3xl">
            <img
              className="h-72 md:h-96 lg:h-3/6   object-cover w-full md:ml-0 rounded-t-3xl"
              src={img2}
              alt=""
            />
            <div className="px-6 text-start  pb-6 lg:pb-6">
              <h3 className="text-4xl">Men's footware</h3>
              <p className="mt-6 text-base">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa
                ipsa delectus quod?
              </p>
              <button className="mt-4 rounded-lg bg-[rgb(3,124,193)] px-6 py-2 text-white transition hover:translate-y-1">
                Shop Now
              </button>
            </div>
          </div>

          <div className="row-span-3 bg-[rgb(133,194,39,0.2)] flex flex-col gap-4 rounded-t-3xl">
            <img
              className=" h-72 md:h-96 lg:h-4/6  object-cover w-full md:ml-0 rounded-t-3xl"
              src={img3}
              alt=""
            />
            <div className=" px-6 text-start  pb-6 lg:pb-6">
              <h3 className="text-4xl">Women's apperal</h3>
              <p className="mt-6 text-base">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa
                ipsa delectus quod?
              </p>
              <button className="mt-4 rounded-lg bg-[rgb(133,194,39)] px-6 py-2 text-white transition hover:translate-y-1">
                Shop Now
              </button>
            </div>
          </div>

          <div className="row-span-2 bg-[rgb(220,19,123,0.2)] gap-4 md:flex md:flex-col rounded-t-3xl">
            <img
              className="h-72 md:h-96 lg:h-3/6  object-cover w-full md:ml-0 rounded-t-3xl"
              src={img4}
              alt=""
            />
            <div className="px-6 text-start  pb-6 lg:pb-6">
              <h3 className="text-4xl">Men's appreal</h3>
              <p className="mt-6 text-base">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa
                ipsa delectus quod?
              </p>
              <button className="mt-4 rounded-lg bg-[rgb(220,19,123)] px-6 py-2 text-white transition hover:translate-y-1">
                Shop Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cards;
